import React, { useMemo } from 'react';
import styles from './GreenSparks.module.css';

const SPARK_COUNT = 50;

const GreenSparks = () => {
  const sparks = useMemo(
    () =>
      Array.from({ length: SPARK_COUNT }, (_, i) => {
        const size = 2 + Math.random() * 4;
        return {
          id: i,
          left: Math.random() * 100,
          top: Math.random() * 100,
          size,
          duration: 6 + Math.random() * 10,
          delay: -Math.random() * 12,
          drift: (Math.random() - 0.5) * 120,
          opacity: 0.25 + Math.random() * 0.5,
        };
      }),
    []
  );

  return (
    <div className={styles.sparks} aria-hidden="true">
      {sparks.map((s) => (
        <span
          key={s.id}
          className={styles.spark}
          style={{
            left: `${s.left}%`,
            top: `${s.top}%`,
            width: `${s.size}px`,
            height: `${s.size}px`,
            animationDuration: `${s.duration}s`,
            animationDelay: `${s.delay}s`,
            '--drift': `${s.drift}px`,
            '--spark-opacity': s.opacity,
          }}
        />
      ))}
    </div>
  );
};

export default GreenSparks;
